module.exports = __webpack_public_path__ + "img/__icon_DŁUŻYCA.fcebf029.svg";